import { Parcel } from '@web/types/order';
import { ItemWithRollbackState } from './editing';

export type ParcelWithRollbackState = ItemWithRollbackState<Parcel>;
